<template>
  <v-container fluid>

    <v-card class="ma-2 rounded-lg">

      <v-card-title class="secondary--text">

        <v-img
          class="ml-2"
          max-width="24"
          max-height="24"
          src="/img/icons/wallet.svg"
        />

        مدیریت کیف پول کاربران

      </v-card-title>

      <v-divider />

      <v-card-text>

        <m-datatable
          ref="datatable"
          :show-select="false"
          :show-filter-row="false"
          :show-export-btns="false"
          :headers="headers"
          :apiUrl="url"
          :filters.sync="filters"
        >

          <template #item.full_name="{ item }">

            <div>
              <div class="font-weight-bold">
                {{ item.full_name }}
              </div>

              <div class="caption grey--text">
                {{ item.username }}
              </div>
            </div>

          </template>

          <template #item.wallet_balance="{ item }">

            <v-chip
              color="success"
              outlined
            >
              {{ toMoney(item.wallet_balance) }}
            </v-chip>

          </template>

          <template #item.actions="{ item }">

            <v-tooltip bottom>

              <template v-slot:activator="{ on, attrs }">

                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="openWalletDialog(item)"
                >
                  <v-img
                    max-width="20"
                    max-height="20"
                    src="/img/icons/pencil.svg"
                  />
                </v-btn>

              </template>

              ویرایش کیف پول

            </v-tooltip>

          </template>

        </m-datatable>

      </v-card-text>

    </v-card>

    <v-dialog
      v-model="walletDialog"
      max-width="600"
      persistent
    >
      <v-card>

        <v-card-title>
          ویرایش کیف پول
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-4">

          <v-alert
            outlined
            dense
            type="info"
          >
            {{ selectedUser.first_name }} {{ selectedUser.last_name }} - {{ selectedUser.username }}
          </v-alert>

          <v-row>

            <v-col cols="12">

              <v-text-field
                outlined
                readonly
                label="موجودی فعلی"
                :value="toMoney(selectedUser.wallet_balance)"
              />

            </v-col>

            <v-col cols="12">

              <v-select
                v-model="form.operation"
                :items="operations"
                item-text="text"
                item-value="value"
                label="نوع عملیات"
                outlined
              />

            </v-col>

            <v-col cols="12">

              <v-text-field
                v-model="form.amount"
                type="number"
                outlined
                label="مبلغ"
              />

            </v-col>

          </v-row>

        </v-card-text>

        <v-divider />

        <v-card-actions>

          <v-spacer />

          <v-btn
            text
            @click="walletDialog = false"
          >
            انصراف
          </v-btn>

          <v-btn
            color="primary"
            @click="submitWallet"
          >
            ذخیره
          </v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

  </v-container>
</template>

<script>
export default {
  name: "AdminWalletPage",

  data() {
    return {
      url: "sobhanAdmin/wallet/",

      filters: {},

      walletDialog: false,

      selectedUser: {},

      form: {
        user_id: null,
        amount: null,
        operation: "set",
      },

      operations: [
        {
          text: "افزایش موجودی",
          value: "add",
        },
        {
          text: "کاهش موجودی",
          value: "subtract",
        },
        {
          text: "تنظیم موجودی",
          value: "set",
        },
      ],
    };
  },

  computed: {
    headers() {
      return [
        {
          text: "نام",
          value: "first_name",
        },
        {
          text: "نام خانوادگی",
          value: "last_name",
        },
        {
          text: "شماره موبایل",
          value: "phone",
        },
        {
          text: "موجودی کیف پول",
          value: "wallet_balance",
        },
        {
          text: "عملیات",
          value: "actions",
          sortable: false,
          filterable: false,
        },
      ];
    },
  },

  methods: {

    openWalletDialog(item) {

      this.selectedUser = item;

      this.form = {
        user_id: item.id,
        amount: null,
        operation: "set",
      };

      this.walletDialog = true;

    },

    submitWallet() {

      this.request({
        url: this.endpoint("sobhanAdmin/wallet/update/"),
        method: "post",
        data: this.form,

        success: (data) => {

          this.notify('عملیات با موفقیت انجام شد.', 'success');

          this.walletDialog = false;

          this.$refs.datatable.getDataFromApi();

        }
      });

    },

  },
};
</script>